"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcSliderBehavior = void 0;
var helpers_1 = require("../../../common/helpers");
var default_behavior_1 = require("../../../common/models/default-behavior");
var tooltip_constants_1 = require("../../molecules/bc-tooltip/tooltip-constants");
var bc_slider_constants_1 = require("./bc-slider-constants");
var bc_slider_constants_2 = require("./bc-slider-constants");
var bc_slider_constants_3 = require("./bc-slider-constants");
var bc_slider_constants_4 = require("./bc-slider-constants");
var bc_slider_constants_5 = require("./bc-slider-constants");
var bc_slider_constants_6 = require("./bc-slider-constants");
var bc_slider_constants_7 = require("./bc-slider-constants");
var bc_slider_constants_8 = require("./bc-slider-constants");
var common_constants_1 = require("../../../common/constants/common-constants");
var BcSliderBehavior = (function (_super) {
    __extends(BcSliderBehavior, _super);
    function BcSliderBehavior() {
        var _this = _super.call(this) || this;
        _this.secondaryThumbs = {};
        _this.total = 0;
        _this.previousTotal = 0;
        _this.numberOfThumbs = 0;
        _this.thumbsSeparation = 0;
        _this.hasTooltip = false;
        return _this;
    }
    BcSliderBehavior.prototype._setUp = function () {
        this.setElement(this.mySelf);
        this.addInputListener();
        this.addTooltipListeners();
        this.updateInput();
    };
    BcSliderBehavior.prototype.setValue = function (value) {
        this.slider.value = value;
        this.updateInput();
    };
    BcSliderBehavior.prototype.setNumberOfThumbs = function (thumbs) {
        if (thumbs !== bc_slider_constants_8.SLIDER_N5 && thumbs !== bc_slider_constants_8.SLIDER_N11) {
            this.numberOfThumbs = 0;
            return;
        }
        this.numberOfThumbs = thumbs;
    };
    BcSliderBehavior.prototype.enableTooltip = function () {
        this.hasTooltip = true;
    };
    BcSliderBehavior.prototype.setElement = function (element) {
        this.slider = element.querySelector("input[class^='".concat(bc_slider_constants_1.SLIDER_INPUT_CLASS, "']"));
        this.setThumb();
        this.setTrack();
        this.setSecondaryThumbs();
        this.setTooltip();
    };
    BcSliderBehavior.prototype.setThumb = function () {
        this.thumb = this.mySelf.querySelector("[class='".concat(bc_slider_constants_1.SLIDER_THUMB_CLASS, "']"));
        if (this.thumb === null) {
            var thumb = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
            thumb.classList.add(bc_slider_constants_1.SLIDER_THUMB_CLASS);
            this.mySelf.appendChild(thumb);
            this.thumb = thumb;
        }
        (0, helpers_1.addFocusable)(this.mySelf, null, null, [this.thumb]);
    };
    BcSliderBehavior.prototype.setTrack = function () {
        this.track = this.mySelf.querySelector("[class='".concat(bc_slider_constants_2.SLIDER_TRACK_CLASS, "']"));
        if (this.track === null) {
            var track = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
            track.classList.add(bc_slider_constants_2.SLIDER_TRACK_CLASS);
            this.track = track;
            this.setFilledTrack();
            this.mySelf.insertBefore(track, this.slider);
            return;
        }
        this.setFilledTrack();
    };
    BcSliderBehavior.prototype.setFilledTrack = function () {
        this.filledTrack = this.track.querySelector("[class='".concat(bc_slider_constants_2.SLIDER_TRACK_FILL_CLASS, "']"));
        if (this.filledTrack === null) {
            var filledTrack = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
            filledTrack.classList.add(bc_slider_constants_2.SLIDER_TRACK_FILL_CLASS);
            this.track.appendChild(filledTrack);
            this.filledTrack = filledTrack;
        }
    };
    BcSliderBehavior.prototype.setSecondaryThumbs = function () {
        if (this.numberOfThumbs === 0) {
            this.secondaryThumbs = null;
            return;
        }
        var thumbsContainer = this.mySelf.querySelector("[class='".concat(bc_slider_constants_3.SLIDER_SECONDARY_THUMBS_CONTAINER_CLASS, "']"));
        if (thumbsContainer === null) {
            thumbsContainer = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
            thumbsContainer.classList.add(bc_slider_constants_3.SLIDER_SECONDARY_THUMBS_CONTAINER_CLASS);
        }
        this.generateSecondaryThumbs(thumbsContainer);
        this.mySelf.insertBefore(thumbsContainer, this.track);
    };
    BcSliderBehavior.prototype.generateSecondaryThumbs = function (thumbsContainer) {
        this.thumbsSeparation = bc_slider_constants_7.SLIDER_N100 / (this.numberOfThumbs - bc_slider_constants_6.SLIDER_N1);
        for (var i = 0; i < this.numberOfThumbs; i++) {
            var secondaryThumb = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
            secondaryThumb.className = bc_slider_constants_3.SLIDER_SECONDARY_THUMB_CLASS;
            secondaryThumb.dataset.position = "".concat(i * this.thumbsSeparation);
            this.secondaryThumbs[i * this.thumbsSeparation] = secondaryThumb;
            thumbsContainer.appendChild(secondaryThumb);
        }
    };
    BcSliderBehavior.prototype.setTooltip = function () {
        if (!this.hasTooltip) {
            this.tooltip = null;
            return;
        }
        var tooltip = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        tooltip.classList.add(bc_slider_constants_1.SLIDER_TOOLTIP);
        tooltip.classList.add(tooltip_constants_1.BC_TOOLTIP_CONTAINER_SELECTOR);
        var tooltipText = document.createElement(common_constants_1.BcCommonConstants.P_TAG);
        var tooltipArrow = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        tooltipArrow.classList.add(tooltip_constants_1.BC_TOOLTIP_ARROW_CLASS);
        tooltipArrow.classList.add("".concat(tooltip_constants_1.BC_TOOLTIP_ARROW_CLASS, "--top"));
        tooltip.appendChild(tooltipText);
        tooltip.appendChild(tooltipArrow);
        this.tooltipText = tooltipText;
        this.mySelf.insertBefore(tooltip, this.slider);
        this.tooltip = tooltip;
    };
    BcSliderBehavior.prototype.updateInput = function () {
        this.calculateTotal();
        this.defineCssProperties();
        this.outputValues();
        this.toggleAnimationClasses();
        this.styleSecondaryThumbs();
        this.repositionSlider();
        this.updateTooltip();
    };
    BcSliderBehavior.prototype.outputValues = function () {
        if (this.outputFunction) {
            this.outputFunction({ value: parseInt(this.slider.value), percentage: this.total });
        }
    };
    BcSliderBehavior.prototype.calculateTotal = function () {
        var inputMinValue = parseInt(this.slider.getAttribute('min'));
        var inputMaxValue = parseInt(this.slider.getAttribute('max'));
        var inputCurrentValue = parseInt(this.slider.value);
        var rangeSize = inputMaxValue - inputMinValue;
        this.total = ((inputCurrentValue - inputMinValue) * bc_slider_constants_7.SLIDER_N100) / rangeSize;
    };
    BcSliderBehavior.prototype.defineCssProperties = function () {
        var thumbOffsetOnHover = (bc_slider_constants_6.SLIDER_N4 * this.total) / bc_slider_constants_7.SLIDER_N100 - bc_slider_constants_6.SLIDER_N2;
        this.slider.style.setProperty('--value', "".concat(this.total));
        this.slider.style.setProperty('--thumbOffsetOnHover', "".concat(thumbOffsetOnHover, "px"));
        this.slider.setAttribute('aria-valuenow', this.slider.value);
    };
    BcSliderBehavior.prototype.styleSecondaryThumbs = function () {
        var _this = this;
        if (this.numberOfThumbs === 0 || this.total === this.previousTotal) {
            return;
        }
        var steps = Math.abs(this.total - this.previousTotal) / this.thumbsSeparation;
        var index = 0;
        var delay = 0;
        if (this.total > this.previousTotal) {
            var _loop_1 = function (i) {
                delay = (bc_slider_constants_5.SLIDER_ANIMATION_DURATION / steps) * index;
                setTimeout(function () {
                    _this.secondaryThumbs[i].classList.add(bc_slider_constants_4.SLIDER_ACTIVE_CLASS);
                }, delay);
                index++;
            };
            for (var i = this.previousTotal; i <= this.total; i += this.thumbsSeparation) {
                _loop_1(i);
            }
            return;
        }
        var _loop_2 = function (i) {
            delay = (bc_slider_constants_5.SLIDER_ANIMATION_DURATION / steps) * index;
            setTimeout(function () {
                _this.secondaryThumbs[i].classList.remove(bc_slider_constants_4.SLIDER_ACTIVE_CLASS);
            }, delay);
            index++;
        };
        for (var i = this.previousTotal; i >= this.total; i -= this.thumbsSeparation) {
            _loop_2(i);
        }
    };
    BcSliderBehavior.prototype.repositionSlider = function () {
        var leftOffset = (bc_slider_constants_7.SLIDER_N32 * this.total) / bc_slider_constants_7.SLIDER_N100;
        this.thumb.style.left = "calc(".concat(this.total, "% - ").concat(leftOffset, "px)");
        this.filledTrack.style.width = "".concat(this.total, "%");
    };
    BcSliderBehavior.prototype.updateTooltip = function () {
        if (!this.hasTooltip) {
            return;
        }
        var tooltipLeft = ((bc_slider_constants_7.SLIDER_N52 - bc_slider_constants_6.SLIDER_N20) / bc_slider_constants_7.SLIDER_N100) * this.total + bc_slider_constants_6.SLIDER_N20;
        this.tooltip.style.left = "calc(".concat(this.total, "% - ").concat(tooltipLeft, "px)");
        this.tooltipText.innerText = "".concat(Math.round(this.total), "%");
    };
    BcSliderBehavior.prototype.addInputListener = function () {
        var _this = this;
        this.slider.addEventListener(common_constants_1.BcCommonConstants.EVENT_INPUT, function () {
            _this.previousTotal = _this.total;
            _this.updateInput();
        });
    };
    BcSliderBehavior.prototype.addTooltipListeners = function () {
        var _this = this;
        if (!this.hasTooltip) {
            return;
        }
        this.slider.addEventListener(common_constants_1.BcCommonConstants.EVENT_MOUSEDOWN, function () {
            _this.tooltip.classList.add(bc_slider_constants_4.SLIDER_ACTIVE_CLASS);
        });
        this.slider.addEventListener(common_constants_1.BcCommonConstants.EVENT_MOUSEUP, function () {
            _this.tooltip.classList.remove(bc_slider_constants_4.SLIDER_ACTIVE_CLASS);
        });
        this.slider.addEventListener('touchstart', function () {
            _this.tooltip.classList.add(bc_slider_constants_4.SLIDER_ACTIVE_CLASS);
        });
        this.slider.addEventListener('touchend', function () {
            _this.tooltip.classList.remove(bc_slider_constants_4.SLIDER_ACTIVE_CLASS);
        });
    };
    BcSliderBehavior.prototype.toggleAnimationClasses = function () {
        var _this = this;
        var significantChangeDetected = Math.abs(this.total - this.previousTotal) >= bc_slider_constants_5.SLIDER_SIGNIFICANT_CHANGE;
        if (!significantChangeDetected) {
            return;
        }
        this.slider.classList.add(bc_slider_constants_4.SLIDER_HIDDEN_CLASS);
        this.thumb.classList.add(bc_slider_constants_4.SLIDER_VISIBLE_CLASS);
        this.filledTrack.classList.add(bc_slider_constants_1.SLIDER_MOVING_CLASS);
        if (this.hasTooltip) {
            this.tooltip.classList.add(bc_slider_constants_1.SLIDER_MOVING_CLASS);
        }
        setTimeout(function () {
            _this.slider.classList.remove(bc_slider_constants_4.SLIDER_HIDDEN_CLASS);
        }, bc_slider_constants_5.SLIDER_ANIMATION_DURATION / bc_slider_constants_6.SLIDER_N2);
        setTimeout(function () {
            _this.thumb.classList.remove(bc_slider_constants_4.SLIDER_VISIBLE_CLASS);
            _this.filledTrack.classList.remove(bc_slider_constants_1.SLIDER_MOVING_CLASS);
            if (_this.hasTooltip) {
                _this.tooltip.classList.remove(bc_slider_constants_1.SLIDER_MOVING_CLASS);
            }
        }, bc_slider_constants_5.SLIDER_ANIMATION_DURATION);
    };
    return BcSliderBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcSliderBehavior = BcSliderBehavior;
